// extracted by mini-css-extract-plugin
export default {"formContainer":"Form1_formContainer__9Iz3L","sideContainer":"Form1_sideContainer__aT6To","birthdayContainer":"Form1_birthdayContainer__F9blR","title":"Form1_title__alGUh"};